// src/pages/BookingDetail.jsx
import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import { useTenant } from "../context/TenantContext";
import api from "../services/api";
import {
  FiCalendar,
  FiClock,
  FiMapPin,
  FiArrowLeft,
  FiInfo,
} from "react-icons/fi";
import BookingModal from "../components/Booking/BookingModal";
import "../styles/booking-detail.css";

const formatDuration = (minutes) => {
  if (!minutes) return "Flexible";
  if (minutes < 60) return `${minutes} minutes`;
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return mins > 0
    ? `${hours}h ${mins}m`
    : `${hours} hour${hours > 1 ? "s" : ""}`;
};

const BookingDetail = () => {
  const { id } = useParams();
  const { tenant } = useTenant();
  const navigate = useNavigate();
  const [showBooking, setShowBooking] = useState(false);

  const { data: productData, isLoading } = useQuery(
    ["booking-product", tenant?.TenantID, id],
    async () => {
      const response = await api.get(`/api/products/${id}`);
      return response.data.product;
    },
    { enabled: !!tenant && !!id },
  );

  if (isLoading) {
    return (
      <div className="booking-detail-loading">
        <div className="spinner"></div>
      </div>
    );
  }

  if (!productData) {
    return (
      <div className="booking-detail-error">
        <h2>Service not found</h2>
        <button onClick={() => navigate("/")}>Go Back Home</button>
      </div>
    );
  }

  return (
    <div className="booking-detail-page">
      <div className="container">
        <button className="back-button" onClick={() => navigate(-1)}>
          <FiArrowLeft /> Back
        </button>

        <div className="booking-detail-grid">
          <div className="booking-detail-image">
            <img
              src={productData.ImageUrl || "https://via.placeholder.com/500"}
              alt={productData.Name}
            />
            {productData.Duration && (
              <div className="duration-badge">
                <FiClock /> {formatDuration(productData.Duration)}
              </div>
            )}
          </div>

          <div className="booking-detail-info">
            <h1>{productData.Name}</h1>

            <div className="detail-meta">
              <span className="detail-location">
                <FiMapPin />{" "}
                {productData.LocationType === "online"
                  ? "Online / Virtual"
                  : "In-Person"}
              </span>
              {productData.BookingRequired && (
                <span className="detail-booking-badge">
                  <FiCalendar /> Booking Required
                </span>
              )}
            </div>

            <div className="detail-price">
              R{productData.SellingPrice?.toLocaleString()}
            </div>

            {productData.Description && (
              <div className="detail-description">
                <h3>About this service</h3>
                <p>{productData.Description}</p>
              </div>
            )}

            {productData.BookingInstructions && (
              <div className="detail-instructions">
                <h3>
                  <FiInfo /> Important Information
                </h3>
                <p>{productData.BookingInstructions}</p>
              </div>
            )}

            <button
              className="book-now-btn"
              onClick={() => setShowBooking(true)}
              style={{ backgroundColor: tenant?.PrimaryColor }}
            >
              <FiCalendar />
              Book Now
            </button>
          </div>
        </div>
      </div>

      <BookingModal
        isOpen={showBooking}
        onClose={() => setShowBooking(false)}
        product={productData}
      />
    </div>
  );
};

export default BookingDetail;
